/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logging_InInputs */

const vi_auth_logging_in = /** @type {(inputs: Auth_Logging_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đăng nhập...`)
};

/**

* @param {Auth_Logging_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const auth_logging_in = /** @type {((inputs?: Auth_Logging_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logging_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_auth_logging_in(inputs)
});